import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { dateFormat } from "../../../util/DateUtil";
import { isVigente } from "../cronogramaUtil";

/** Cabeçalho do período selecionado, com o botão para trocar. */
export default function CronogramaDataProfile({ cronogramaData, onTrocar }) {
  return (
    <Paper variant="outlined" sx={{ borderRadius: 2, p: 2 }}>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems={{ sm: "center" }}>
        <Box flexGrow={1}>
          <Typography variant="caption" color="text.secondary">
            Período
          </Typography>
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="subtitle1" fontWeight={600}>
              {dateFormat(cronogramaData.dataInicio)} até{" "}
              {cronogramaData.dataFim ? dateFormat(cronogramaData.dataFim) : "sem data fim"}
            </Typography>
            {isVigente(cronogramaData) && <Chip size="small" color="success" variant="outlined" label="Vigente" />}
          </Stack>
        </Box>
        <Button className="no-print" startIcon={<SwapHorizIcon />} onClick={onTrocar} sx={{ flexShrink: 0 }}>
          Trocar Período
        </Button>
      </Stack>
    </Paper>
  );
}
